import React from 'react';

import { Badge } from '@/components/shadcn/ui/badge';

type HeaderWalletDrawerBalancesInfoBadgesProps = {
  items: string[];
};

const HeaderWalletDrawerBalancesInfoBadges: React.FC<HeaderWalletDrawerBalancesInfoBadgesProps> = ({ items }) => {
  if (!items?.length) return null;

  return (
    <span className="inline-flex items-center gap-1">
      {items.map((item) => (
        <Badge key={item} className="text-muted-foreground px-1 py-0 text-[10px] font-normal">
          {item}
        </Badge>
      ))}
    </span>
  );
};

export default HeaderWalletDrawerBalancesInfoBadges;
